import React from "react";
import { GraduationCap, BookOpen, School } from "lucide-react";
import { useContent } from "../context/ContentContext";

const Academics = () => {
  const { academics } = useContent();
  return (
    <section className="relative py-24 md:py-28 bg-black border-t border-neutral-900">
      <div className="max-w-7xl mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3 mb-4">
            <span className="accent-bar" />
            <span className="text-xs uppercase tracking-[0.35em] text-neutral-400 font-heading">
              06 — Academics
            </span>
          </div>
          <h2 className="font-display text-5xl md:text-6xl text-white leading-none">
            STUDENT <br />
            <span className="text-red-600">ATHLETE</span>
          </h2>
          <p className="mt-6 text-neutral-300 max-w-md">
            Disciplined in the classroom, relentless on the field. Building a foundation of grades, character, and football IQ for the next level.
          </p>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-3 gap-4">
          <div className="stat-card border border-neutral-800 bg-neutral-900/60 rounded-sm p-6">
            <GraduationCap className="w-6 h-6 text-red-500 mb-4" />
            <div className="text-[10px] uppercase tracking-[0.3em] text-neutral-500 font-heading">
              GPA
            </div>
            <div className="font-display text-5xl text-white mt-1">{academics.gpa}</div>
          </div>
          <div className="stat-card border border-neutral-800 bg-neutral-900/60 rounded-sm p-6">
            <School className="w-6 h-6 text-red-500 mb-4" />
            <div className="text-[10px] uppercase tracking-[0.3em] text-neutral-500 font-heading">
              School
            </div>
            <div className="font-display text-2xl text-white mt-1 leading-tight">
              {academics.school}
            </div>
          </div>
          <div className="stat-card border border-neutral-800 bg-neutral-900/60 rounded-sm p-6">
            <BookOpen className="w-6 h-6 text-red-500 mb-4" />
            <div className="text-[10px] uppercase tracking-[0.3em] text-neutral-500 font-heading">
              Graduation
            </div>
            <div className="font-display text-2xl text-white mt-1">
              {academics.graduation}
            </div>
          </div>

          <div className="sm:col-span-3 mt-2 flex flex-wrap gap-2">
            {academics.focus.map((f) => (
              <span
                key={f}
                className="text-xs uppercase tracking-[0.25em] font-heading text-neutral-300 border border-neutral-700 rounded-sm px-3 py-1.5"
              >
                {f}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Academics;
